import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Case Management API - Base definition
 *
 * This is the base API slice for the Case Management service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see policyEndpoints.ts - Policy CRUD operations
 * @see worklistEndpoints.ts - Worklist queries
 * @see caseEndpoints.ts - Case management operations
 */
export const caseManagementApi = createApi({
  reducerPath: 'caseManagementApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.caseManagement),
  tagTypes: ['Policy', 'PolicyList', 'Worklist', 'CaseManagement'],
  endpoints: () => ({}),
});
